module.exports = __webpack_public_path__ + "img/linkedin.9dfeb0ac.svg";